import React from 'react';
import { PieChart, Pie, Sector} from 'recharts';
import {
    collection,
    getDocs,
    query,
    where,
    orderBy,
} from "firebase/firestore";
import moment from 'moment';
import { db } from "../../utils/firebase";
import { useAuth } from "../../contexts/AuthContext";
import { useEffect, useState, useCallback, useRef } from "react";
import "./styles.css";

const renderActiveShape = (props) => {
    const RADIAN = Math.PI / 180;
    const {
      cx,
      cy,
      midAngle,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle,
      fill,
      payload,
      percent,
      value
    } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? "start" : "end";
  
    return (
      <g>
        <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
          {payload.category}
        </text>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
        <Sector
          cx={cx}
          cy={cy}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={outerRadius + 6}
          outerRadius={outerRadius + 10}
          fill={fill}
        />
        <path
          d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
          stroke={fill}
          fill="none"
        />
        <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
        <text
          x={ex + (cos >= 0 ? 1 : -1) * 12}
          y={ey}
          textAnchor={textAnchor}
          fill="#333"
        >{`$${value}`}</text>
        <text
          x={ex + (cos >= 0 ? 1 : -1) * 12}
          y={ey}
          dy={18}
          textAnchor={textAnchor}
          fill="#3c3c3c"
        >
          {`(${(percent * 100).toFixed(0)}%)`}
        </text>
      </g>
    );
};

const IncomePieChart = () => {
    const { currentUser } = useAuth();
    const dataFetchedRef = useRef(false);
    const [pieData, setPieData] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const onPieEnter = useCallback(
      (_, index) => {
        setActiveIndex(index);
      },
      [setActiveIndex]
    );

    const transactionsCollectionRef = query(
        collection(db, "transactions"),
        where("uId", "==", currentUser.auth.currentUser.uid),
        orderBy("date", "desc")
    );

    var categoryCountData = [];

    const setIncomeTransactionData = async () => {
        const data = await getDocs(transactionsCollectionRef);

        // get income transactions for current month
        const dataMap = data.docs.map((doc) => ({ ...doc.data(), id: doc.id })).filter(d => d.type === "Income" && moment(d.date).format('MMMM YYYY') === moment().format('MMMM YYYY'));

        // gets the categories that there are transactions for
        var keys = [...new Map(dataMap.map(trans => [trans["category"], trans])).values()]

        //creates an object for each category with a total amount
        //example, pushes {category: 'Work', count: 1}
        keys.forEach(cat => {
            let initialValue = 0;
            let transForCat = dataMap.filter(trans => trans.category === cat.category);
            //console.log(transForCat);
            let amount = transForCat.map(trans => Number(trans.amount)).reduce((prev, next) => prev += next, initialValue);
            // console.log("Category: " + cat.category);
            console.log(amount);
            categoryCountData.push({ category: cat.category, amount: amount });
        })
        // console.log("Data");
         console.log(categoryCountData);

        //result of categoryCountData is an array of category-count values
        //example, [{category: 'Work', amount: 1}, {category: 'Groceries', amount: 2}, {category: 'Donation', amount: 10}]
        setPieData(categoryCountData);
    };

    useEffect(() => {
        // useEffect keeps running twice due to React.StrictMode being on
        // discussed here: https://stackoverflow.com/questions/60618844/react-hooks-useeffect-is-called-twice-even-if-an-empty-array-is-used-as-an-ar
        // temporary workaround: https://upmostly.com/tutorials/why-is-my-useeffect-hook-running-twice-in-react#:~:text=This%20is%20because%20outside%20of,your%20hook%20has%20been%20ran.
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
        setIncomeTransactionData();
    }, []);

    return (
        <>
            {pieData ? 
            (
                <>
                    <h2>Percentage of Income Transactions </h2>
                    <h3><em>({moment().format('MMMM YYYY')})</em></h3>
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                      <PieChart width={400} height={400}>
                          <Pie
                          activeIndex={activeIndex}
                          activeShape={renderActiveShape}
                          data={pieData}
                          cx={200}
                          cy={200}
                          innerRadius={60}
                          outerRadius={80}
                          fill="#198754"
                          dataKey="amount"
                          onMouseEnter={onPieEnter}
                          />
                      </PieChart>
                    </div>
                </>
            ) : null}
        </>
    );
}

export { IncomePieChart };